import { createContext } from "react";
import type { CreateInvoiceContextValue } from "./types";

export const CreateInvoiceContext = createContext<CreateInvoiceContextValue | null>(null);
